import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../../services/apiResponse";

import CreateBloc from "../../../HomeAdmin/Create/Blocs/CreateBloc";
import CustomSelect from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";
import DatePicker from "../../../../../helpers/ui/DatePicker";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

var reformatCategoriesOptions = function (raw) {
  let dictionary = {};
  raw.forEach(data => {
    dictionary[data.employee_categories_uuid] = data;
  });

  let options = [];

  raw.forEach((data) => {
    if (data.employee_categories_parent_uuid) {
      let parent = dictionary[data.employee_categories_parent_uuid];
      let parentName = parent ? parent.employee_categories_name : "";
      
      let childName = data.employee_categories_kode_kemenkeu
        ? `${data.employee_categories_kode_kemenkeu} - ${data.employee_categories_name}`
        : `${data.employee_categories_name}`;
        
      let label = parentName ? `${parentName} \u00BB ${childName}` : childName;
      
      options.push({
        label: label,
        value: data.employee_categories_uuid,
        kode_kemenkeu: data.employee_categories_kode_kemenkeu,
        full_data: data,
      });
    }
  });

  if (options.length > 0) {
    return options;
  }

  return raw.map(function (data) {
    return {
      label: data.employee_categories_kode_kemenkeu
        ? `${data.employee_categories_kode_kemenkeu} - ${data.employee_categories_name}`
        : `${data.employee_categories_name}`,
      value: data.employee_categories_uuid,
      kode_kemenkeu: data.employee_categories_kode_kemenkeu,
      full_data: data,
    };
  });
};

var reformatReligionOptions = function (raw) {
  return raw.map(function (data) {
    return {
      label: `${data.religion_kemenkeu_code} - ${data.religion_name}`,
      value: data.religion_uuid,
      kode_kemenkeu: data.religion_kemenkeu_code,
      full_data: data,
    };
  });
};



var reformatBankSpanOptions = (raw) => {
  if (!raw || !Array.isArray(raw)) {
    return [];
  }

  return raw.map((data) => ({
    label: `${data.kdbankspan} - ${data.nmbankspan}`,
    value: data.kdbankspan,
  }));
};

class FormPegawaiBaru extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      optionGender: [
        { label: "Laki-laki", value: "L" },
        { label: "Perempuan", value: "P" },
      ],
      birthOptionNationality: [
        { label: "Dalam Negeri", value: "Dalam Negeri" },
        { label: "Luar Negeri", value: "Luar Negeri" },
      ],
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthSelectedCity: "",
      birthOptionCountry: [],
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      birthSelectedNational: "Dalam Negeri",
      isLocal: 1,
      //------
      OptionReligion: [],
      OptionMaritalStatus: [],
      OptionBloodType: [],
      domicileOptionProvince: [],
      domicileOptionCity: [],
      domicileOptionDistrict: [],
      domicileOptionVillage: [],
      identityOptionProvince: [],
      identityOptionCity: [],
      identityOptionDistrict: [],
      identityOptionVillage: [],
      OptionBank: [],
      OptionUnit: [],
      OptionEmployeeType: [],
      OptionEmployeeStatus: [],
      OptionSallaryFrom: [
        { label: "Pusat", value: "Pusat" },
        { label: "Daerah", value: "Daerah" },
      ],
      OptionEmployeeStatusDesc: [],
      OptionEmployeeStatusPosition: [],
      educationOption: [],
      rankOption: [],
      positionChannel: [],
      OptionEmpCategories: [],
      categorySelected: "",
      polaKerjaOptions: [],
      selectedPolaKerja: "",
      failedInfo: "",
      enrollnumber: "",
      loadaingtitle: "",
      bankspanGajiwebOption: [],
      religionSelected: "",
      isSameAddress: false,
      identityAddress: "",
      identityPostalCode: "",
      selectedIdentityProvince: null,
      selectedIdentityCity: null,
      selectedIdentityDistrict: null,
      selectedIdentityVillage: null,
      domicileAddress: "",
      domicilePostalCode: "",
      selectedDomicileProvince: null,
      selectedDomicileCity: null,
      selectedDomicileDistrict: null,
      selectedDomicileVillage: null,
      religionKodeKemenkeu: "",
      categoryKodeKemenkeu: "",
      rankSelectedCode: "",
      bankSelectedName: "",
      birthSelectedCityText: "",
    };
    this.timeout = null;
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  // Start Select Area
  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
        isLocal: 1,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        isLocal: 0,
      });
    }
  };

  handleBirthSelectCountry = (birthSelectedCountry) => {
    let selected = birthSelectedCountry.value;
    this.getBirthProvinceByCountry(selected);
  };

  getBirthProvinceByCountry = (country_uuid) => {
    // Luar negeri doesn't have local provinces in the DB based on type=3, 
    // but the original code calls this. We will just load state properly or mock it.
    // If CreateBloc doesn't have fetchRegionProvinceByCountry, we gracefully set empty options.
    if (this.createBloc && typeof this.createBloc.fetchRegionProvince === 'function') {
      this.createBloc.fetchRegionProvince({
        is_local: 0,
        type: 2,
        parent_uuid: country_uuid,
      });
    } else {
      this.setState({ OptionBirthProvince: [] });
    }
  };

  handleBirthSelectProvince = (birthSelectedProvince) => {
    let selected = birthSelectedProvince.value;
    this.getBirthCityByProvince(selected);
  };

  // get data city where province selected
  getBirthCityByProvince = (province_uuid) => {
    this.createBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleDomicileSelectProvince = (domicileSelectedProvince) => {
    let selected = domicileSelectedProvince.value;
    this.setState({ selectedDomicileProvince: domicileSelectedProvince });
    this.getDomicileCityByProvince(selected);
  };

  // get data city where province selected
  getDomicileCityByProvince = (province_uuid) => {
    this.createBloc.fetchDomicileCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleDomicileSelectCity = (domicileSelectedCity) => {
    let selected = domicileSelectedCity.value;
    this.setState({ selectedDomicileCity: domicileSelectedCity });
    this.getDomicileDistrictByCity(selected);
  };

  // get data district where city selected
  getDomicileDistrictByCity = (city_uuid) => {
    this.createBloc.fetchDomicileDistrict({
      is_local: 1,
      type: 4,
      parent_uuid: city_uuid,
    });
  };

  handleDomicileSelectDistrict = (domicileSelectedDistrict) => {
    let selected = domicileSelectedDistrict.value;
    this.setState({ selectedDomicileDistrict: domicileSelectedDistrict });
    this.getDomicileVillageByDistrict(selected);
  };

  // get data village where district selected
  getDomicileVillageByDistrict = (district_uuid) => {
    this.createBloc.fetchDomicileVillage({
      is_local: 1,
      type: 5,
      parent_uuid: district_uuid,
    });
  };

  // ---- Domicile x Identity


  handleSameAddress = (e) => {
    const isChecked = e.target.checked;
    this.setState({ isSameAddress: isChecked });
    if (isChecked) {
      this.setState({
        domicileAddress: this.state.identityAddress,
        domicilePostalCode: this.state.identityPostalCode,
        selectedDomicileProvince: this.state.selectedIdentityProvince,
        selectedDomicileCity: this.state.selectedIdentityCity,
        selectedDomicileDistrict: this.state.selectedIdentityDistrict,
        selectedDomicileVillage: this.state.selectedIdentityVillage,
      });
      if (this.state.selectedIdentityProvince) this.getDomicileCityByProvince(this.state.selectedIdentityProvince.value);
      if (this.state.selectedIdentityCity) this.getDomicileDistrictByCity(this.state.selectedIdentityCity.value);
      if (this.state.selectedIdentityDistrict) this.getDomicileVillageByDistrict(this.state.selectedIdentityDistrict.value);
    }
  };

  handleIdentitySelectProvince = (identitySelectedProvince) => {
    let selected = identitySelectedProvince.value;
    this.setState({ selectedIdentityProvince: identitySelectedProvince });
    if (this.state.isSameAddress) {
      this.setState({ selectedDomicileProvince: identitySelectedProvince });
      this.getDomicileCityByProvince(selected);
    }
    this.getIdentityCityByProvince(selected);
  };

  // get data city where province selected
  getIdentityCityByProvince = (province_uuid) => {
    this.createBloc.fetchIdentityCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleIdentitySelectCity = (identitySelectedCity) => {
    let selected = identitySelectedCity.value;
    this.setState({ selectedIdentityCity: identitySelectedCity });
    if (this.state.isSameAddress) {
      this.setState({ selectedDomicileCity: identitySelectedCity });
      this.getDomicileDistrictByCity(selected);
    }
    this.getIdentityDistrictByCity(selected);
  };

  // get data district where city selected
  getIdentityDistrictByCity = (city_uuid) => {
    this.createBloc.fetchIdentityDistrict({
      is_local: 1,
      type: 4,
      parent_uuid: city_uuid,
    });
  };

  handleIdentitySelectDistrict = (identitySelectedDistrict) => {
    let selected = identitySelectedDistrict.value;
    this.setState({ selectedIdentityDistrict: identitySelectedDistrict });
    if (this.state.isSameAddress) {
      this.setState({ selectedDomicileDistrict: identitySelectedDistrict });
      this.getDomicileVillageByDistrict(selected);
    }
    this.getIdentityVillageByDistrict(selected);
  };

  // get data village where district selected
  getIdentityVillageByDistrict = (district_uuid) => {
    this.createBloc.fetchIdentityVillage({
      is_local: 1,
      type: 5,
      parent_uuid: district_uuid,
    });
  };

  // End Select Area

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, ["file", "file_kk"]);
    await this.createBloc.fetchCreate(formData);
  };



  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: values,
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          loadingTitle: "Mengirim data...",
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: "Data gagal disimpan",
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeCategoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            OptionEmpCategories: reformatCategoriesOptions(
              result.data.response.result,
            ),
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchEmployeeCategories({
      parent_uuid: this.props.categoryUuid,
    });

    // get data birth country
    this.createBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCountry: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRegionCountry({
      type: 1,
    });

    // get data province
    this.createBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRegionProvince({
      is_local: 1,
      type: 2,
    });

    // get city
    this.createBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              birthOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getBirthCityByProvince(this.dataForm ? this.dataForm.employee_place_of_birth_province_uuid : '')

    // get data religion
    this.createBloc.religionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              OptionReligion: reformatReligionOptions(
                result.data.response.result,
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchReligion({});

    // get data marital status
    this.createBloc.maritalStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionMaritalStatus: reformatOptions(
                response.result,
                "marital_status_name",
                "marital_status_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchMaritalStatus({});

    // CHANNEL ADDRESS START

    // get data province domicile
    this.createBloc.domicileProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              domicileOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchDomicileProvince({
      is_local: 1,
      type: 2,
    });

    // get city domicile
    this.createBloc.domicileCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getDomicileCityByProvince(this.dataForm ? this.dataForm.employee_domicile_province_uuid : '')

    // get district domicile
    this.createBloc.domicileDistrictChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionDistrict: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getDomicileDistrictByCity(this.dataForm ? this.dataForm.employee_domicile_city_uuid : '')

    // get village domicile
    this.createBloc.domicileVillageChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionVillage: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getDomicileVillageByDistrict(this.dataForm ? this.dataForm.employee_domicile_districts_uuid : '')

    // get data province identity
    this.createBloc.identityProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              identityOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchIdentityProvince({
      is_local: 1,
      type: 2,
    });

    // get city identity
    this.createBloc.identityCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getIdentityCityByProvince(this.dataForm ? this.dataForm.employee_identity_province_uuid : '')

    // get district identity
    this.createBloc.identityDistrictChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionDistrict: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getIdentityDistrictByCity(this.dataForm ? this.dataForm.employee_identity_city_uuid : '')

    // get village identity
    this.createBloc.identityVillageChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionVillage: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getIdentityVillageByDistrict(this.dataForm ? this.dataForm.employee_identity_districts_uuid : '')

    // CHANNEL ADDRESS END

    // get data blood type
    this.createBloc.bloodTypeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionBloodType: reformatOptions(
                response.result,
                "blood_type_name",
                "blood_type_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchBloodType({});

    // get data bank
    this.createBloc.bankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionBank: reformatOptions(
                response.result,
                "bank_name",
                "bank_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchBank({});




    this.createBloc.educationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            educationOption: reformatOptions(
              result.data.response.result,
              "education_name",
              "education_uuid",
            ),
            loadingWorkUnit: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEducation({ is_default: 1 });

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            rankOption: result.data.response.result.map(function (data) {
              var newObj = {};
              newObj["label"] = data.rank_kemenkeu_code
                ? `${data.rank_kemenkeu_code} - ${data.rank_name} (${data.rank_group_room})`
                : `${data.rank_name} (${data.rank_group_room})`;
              newObj["value"] = data.rank_uuid;
              newObj["code"] = data.rank_kemenkeu_code;

              return newObj;
            }),
            loadingRank: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRank();


    this.createBloc.polaKerjaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              polaKerjaOptions: this.reformatOptions(
                response.result,
                "working_pattern_name",
                "working_pattern_uuid",
              ),
              isLoadingOptPolaKerja: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchPolaKerja();

    if (this.props.autoFillSignal) {
      this.fillDefaultData();
    }
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.regionCountryChannel?.unsubscribe();
    this.createBloc.regionProvinceChannel?.unsubscribe();
    this.createBloc.regionCityChannel?.unsubscribe();
    this.createBloc.religionChannel?.unsubscribe();
    this.createBloc.maritalStatusChannel?.unsubscribe();
    this.createBloc.domicileProvinceChannel?.unsubscribe();
    this.createBloc.domicileCityChannel?.unsubscribe();
    this.createBloc.domicileDistrictChannel?.unsubscribe();
    this.createBloc.domicileVillageChannel?.unsubscribe();
    this.createBloc.identityProvinceChannel?.unsubscribe();
    this.createBloc.identityCityChannel?.unsubscribe();
    this.createBloc.identityDistrictChannel?.unsubscribe();
    this.createBloc.identityVillageChannel?.unsubscribe();
    this.createBloc.bloodTypeChannel?.unsubscribe();
    this.createBloc.bankChannel?.unsubscribe();


    this.createBloc.educationChannel?.unsubscribe();
    this.createBloc.rankChannel?.unsubscribe();

    this.createBloc.polaKerjaChannel?.unsubscribe();



  }

  componentDidUpdate(prevProps) {
    if (this.props.autoFillSignal && this.props.autoFillSignal !== prevProps.autoFillSignal) {
      this.fillDefaultData();
    }
  }

    fillDefaultData = () => {
    const dv = this.props.defaultValues || {};
    
    // Fill text inputs by name
    const textFields = {
      'employee_nip': dv.new_employee_nip || '',
      'employee_identity_number': dv.employee_identity_number || '',
      'employee_name': dv.new_employee_name || '',
      'employee_front_title': dv.employee_front_title || '',
      'employee_end_title': dv.employee_end_title || '',
      'employee_place_of_birth_national': dv.employee_place_of_birth_national || '',
      'employee_place_of_birth_city_text': dv.employee_place_of_birth_city_text || '',
      'employee_identity_address': dv.employee_identity_address || '',
      'employee_identity_postal_code': dv.employee_identity_postal_code || '',
      'employee_domicile_address': dv.employee_domicile_address || '',
      'employee_domicile_postal_code': dv.employee_domicile_postal_code || '',
      'employee_mobile_phone_number': dv.employee_mobile_phone_number || '',
      'employee_phone_number': dv.employee_phone_number || '',
      'employee_email_internal': dv.employee_email_internal || '',
      'employee_email_external': dv.employee_email_external || '',
      'employee_karpeg_number': dv.employee_karpeg_number || '',
      'employee_dosir_number': dv.employee_dosir_number || '',
      'employee_npwp_number': dv.employee_npwp_number || '',
      'employee_askes_number': dv.employee_askes_number || '',
      'employee_taspen_number': dv.employee_taspen_number || '',
      'employee_tapera_number': dv.employee_tapera_number || '',
      'employee_bank_account_name': dv.employee_bank_account_name || '',
      'employee_bank_account_number': dv.employee_bank_account_number || ''
    };

    Object.keys(textFields).forEach(name => {
      const el = document.querySelector(`input[name="${name}"]`);
      if (el) {
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        if (nativeInputValueSetter) {
          nativeInputValueSetter.call(el, textFields[name]);
        } else {
          el.value = textFields[name];
        }
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Trigger API calls for dependent selects
    if (dv.employee_place_of_birth_province_uuid) this.getBirthCityByProvince(dv.employee_place_of_birth_province_uuid);
    
    if (dv.employee_identity_province_uuid) this.getIdentityCityByProvince(dv.employee_identity_province_uuid);
    if (dv.employee_identity_city_uuid) this.getIdentityDistrictByCity(dv.employee_identity_city_uuid);
    if (dv.employee_identity_districts_uuid) this.getIdentityVillageByDistrict(dv.employee_identity_districts_uuid);
    
    if (dv.employee_domicile_province_uuid) this.getDomicileCityByProvince(dv.employee_domicile_province_uuid);
    if (dv.employee_domicile_city_uuid) this.getDomicileDistrictByCity(dv.employee_domicile_city_uuid);
    if (dv.employee_domicile_districts_uuid) this.getDomicileVillageByDistrict(dv.employee_domicile_districts_uuid);

    // Set state directly; CustomSelect will auto-populate when options load
    this.setState({
      dateOfBirth: dv.employee_date_of_birth ? dv.employee_date_of_birth.substring(0, 10) : null,
      employee_date_of_birth: dv.employee_date_of_birth ? dv.employee_date_of_birth.substring(0, 10) : null,
      tmt_cpns: dv.employee_cpns_tmt_date ? dv.employee_cpns_tmt_date.substring(0, 10) : null,
      tmt_pns: dv.employee_pns_tmt_date ? dv.employee_pns_tmt_date.substring(0, 10) : null,
      rank_decree_date: dv.employee_rank_decree_date ? dv.employee_rank_decree_date.substring(0, 10) : null,
      mapping_working_pattern_start_date: dv.mapping_working_pattern_start_date ? dv.mapping_working_pattern_start_date.substring(0, 10) : null,
      mapping_working_pattern_end_date: dv.mapping_working_pattern_end_date ? dv.mapping_working_pattern_end_date.substring(0, 10) : null,
      
      categorySelected: dv.employee_categories_uuid || dv.emp_cat_uuid || '',
      genderSelected: dv.employee_gender || '',
      maritalStatusSelected: dv.employee_marital_status_uuid || '',
      religionSelected: dv.employee_religion_uuid || '',
      bloodTypeSelected: dv.employee_blood_type_uuid || '',
      rankSelectedValue: dv.employee_current_rank_uuid || '',
      salaryPaidFromSelected: dv.employee_salary_paid_from || '',
      bankSelectedValue: dv.employee_bank_uuid || '',
      bankSelectedName: dv.employee_categories_bank_name || '',
      
      birthSelectedNational: dv.employee_place_of_birth_national || '',
      birthSelectedCountry: dv.employee_place_of_birth_country_uuid || '',
      birthSelectedProvince: dv.employee_place_of_birth_province_uuid || '',
      birthSelectedCity: dv.employee_place_of_birth_city_uuid || '',
      
      selectedIdentityProvince: dv.employee_identity_province_uuid || null,
      selectedIdentityCity: dv.employee_identity_city_uuid || null,
      selectedIdentityDistrict: dv.employee_identity_districts_uuid || null,
      selectedIdentityVillage: dv.employee_identity_village_uuid || null,
      
      selectedDomicileProvince: dv.employee_domicile_province_uuid || null,
      selectedDomicileCity: dv.employee_domicile_city_uuid || null,
      selectedDomicileDistrict: dv.employee_domicile_districts_uuid || null,
      selectedDomicileVillage: dv.employee_domicile_village_uuid || null,
      
      selectedPolaKerja: dv.employee_working_pattern_uuid || null,

      identityAddress: dv.employee_identity_address || '',
      identityPostalCode: dv.employee_identity_postal_code || '',
      domicileAddress: dv.employee_domicile_address || '',
      domicilePostalCode: dv.employee_domicile_postal_code || ''
    });
  }

  render() {
    return (
      <Fragment>
        <div className="w-100">

          {/* ==========================================
              CARD 1: IDENTITAS DIRI & KATEGORI
          ========================================== */}
          <Card className="mb-4 shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5" className="text-primary font-weight-bold border-bottom pb-3 mb-4">
                Identitas Pribadi
              </CardTitle>
              <Row>
                <Col md={12}>
                  <AvGroup className="mb-3">
                    <Label htmlFor="kat" className="font-weight-bold mb-1">Kategori Pegawai <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_categories_uuid"
                      errorMessage="Pilih Kategori Pegawai"
                      onChange={(v) =>
                        this.setState({
                          categorySelected: v.value,
                          categoryKodeKemenkeu: v.kode_kemenkeu,
                        })
                      }
                      options={this.state.OptionEmpCategories}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Kategori Pegawai"
                      defaultValue={this.state.categorySelected}
                    />
                    <AvField
                      type="hidden"
                      name="employee_categories_kode_kemenkeu"
                      value={this.state.categoryKodeKemenkeu || ""}
                    />
                  </AvGroup>
                </Col>

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">NIP <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_nip"
                      placeholder="NIP"
                      type="text"
                      errorMessage="Masukkan NIP 18 Digit"
                      className="form-control"
                      minLength="18"
                      maxLength="18"
                      validate={{ required: { value: true } }}
                      id="employee_nip"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">NIK <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_identity_number"
                      placeholder="NIK"
                      type="text"
                      errorMessage="Masukkan NIK"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="employee_identity_number"
                    />
                  </AvGroup>
                </Col>

                <Col md={12}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Nama Lengkap <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_name"
                      placeholder="Nama"
                      type="text"
                      errorMessage="Masukkan Nama"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="employee_name"
                    />
                  </AvGroup>
                </Col>

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Gelar Depan</Label>
                    <AvField
                      name="employee_front_title"
                      placeholder="Gelar Depan"
                      type="text"
                      errorMessage="Masukkan Gelar Depan"
                      className="form-control"
                      id="employee_front_title"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Gelar Belakang</Label>
                    <AvField
                      name="employee_end_title"
                      placeholder="Gelar Belakang"
                      type="text"
                      errorMessage="Masukkan Gelar Belakang"
                      className="form-control"
                      id="employee_end_title"
                    />
                  </AvGroup>
                </Col>

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label htmlFor="tempat_lahir" className="font-weight-bold mb-1">Lokasi Lahir (Dalam / Luar Negeri) <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_place_of_birth_national"
                      errorMessage="Pilih Dalam / Luar Negeri Lahir"
                      onChange={this.handleBirthSelectNationality}
                      options={this.state.birthOptionNationality}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Dalam / Luar Negeri Lahir"
                      defaultValue={this.state.birthSelectedNational}
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label htmlFor="tempat_lahir" className="font-weight-bold mb-1">Negara Lahir <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_place_of_birth_country_uuid"
                      errorMessage="Pilih Negara Lahir"
                      onChange={this.handleBirthSelectCountry}
                      options={this.state.birthOptionCountry}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Negara Lahir"
                      defaultValue={this.state.birthSelectedCountry}
                      isDisabled={this.state.isLocal == 0 ? false : true}
                    />
                  </AvGroup>
                </Col>
                <Col md={6} style={this.state.isLocal == 0 ? { display: "none" } : {}}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Provinsi Lahir <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_place_of_birth_province_uuid"
                      errorMessage="Pilih Provinsi Lahir"
                      onChange={this.handleBirthSelectProvince}
                      options={this.state.birthOptionProvince}
                      validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                      placeholder="Pilih Provinsi Lahir"
                      defaultValue={this.state.birthSelectedProvince}
                    />
                  </AvGroup>
                </Col>
                <Col md={6} style={this.state.isLocal == 0 ? { display: "none" } : {}}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Kota Lahir <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_place_of_birth_city_uuid"
                      errorMessage="Pilih Kota Lahir"
                      options={this.state.birthOptionCity}
                      validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                      onChange={(v) =>
                        this.setState({
                          birthSelectedCity: v.value,
                          birthSelectedCityText: v.label,
                        })
                      }
                      placeholder="Pilih Kota Lahir"
                      defaultValue={this.state.birthSelectedCity}
                    />
                    <AvField
                      type="hidden"
                      name="employee_place_of_birth_city_text"
                      value={this.state.birthSelectedCityText || ""}
                    />
                  </AvGroup>
                </Col>
                <Col md={6} style={this.state.isLocal == 1 ? { display: "none" } : {}}>
                  <AvGroup className="mb-3">
                    <Label htmlFor="employee_place_of_birth_city_text" className="font-weight-bold mb-1">Kota Lahir <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_place_of_birth_city_text"
                      placeholder="Kota"
                      type="text"
                      errorMessage="Masukkan Kota"
                      className="form-control"
                      validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                      id="employee_place_of_birth_city_text"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Tanggal Lahir <span className="text-danger">*</span></Label>
                    <div className="customDatePickerWidth">
                      <DatePicker
                        name="employee_date_of_birth"
                        id="employee_date_of_birth"
                        placeholder="Tanggal Lahir"
                        errorMessage="Masukkan Tanggal Lahir"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        validate={{ required: { value: true } }}
                        value={this.state.employee_date_of_birth}
                        onChange={(val) => this.setState({ employee_date_of_birth: val })}
                      />
                    </div>
                  </AvGroup>
                </Col>

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Jenis Kelamin <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_gender"
                      errorMessage="Pilih Jenis Kelamin"
                      options={this.state.optionGender}
                      placeholder="Pilih Jenis Kelamin"
                      defaultValue={this.state.genderSelected}
                      onChange={(opt) => this.setState({ genderSelected: opt?.value })}
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label htmlFor="kat" className="font-weight-bold mb-1">Agama <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_religion_uuid"
                      errorMessage="Pilih Agama"
                      onChange={(v) =>
                        this.setState({
                          religionSelected: v.value,
                          religionKodeKemenkeu: v.kode_kemenkeu,
                        })
                      }
                      options={this.state.OptionReligion}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Agama"
                      defaultValue={this.state.religionSelected}
                    />
                    <AvField
                      type="hidden"
                      name="employee_religion_kode_kemenkeu"
                      value={this.state.religionKodeKemenkeu || ""}
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Status Pernikahan <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_marital_status_uuid"
                      errorMessage="Pilih Status Pernikahan"
                      options={this.state.OptionMaritalStatus}
                      placeholder="Pilih Status Pernikahan"
                      defaultValue={this.state.maritalStatusSelected}
                      onChange={(opt) => this.setState({ maritalStatusSelected: opt?.value })}
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Golongan Darah</Label>
                    <CustomSelect
                      name="employee_blood_type_uuid"
                      errorMessage="Pilih Golongan Darah"
                      options={this.state.OptionBloodType}
                      placeholder="Pilih Golongan Darah"
                      defaultValue={this.state.bloodTypeSelected}
                      onChange={(opt) => this.setState({ bloodTypeSelected: opt?.value })}
                    />
                  </AvGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>


          {/* ==========================================
              CARD 2: KONTAK & ALAMAT
          ========================================== */}
          <Card className="mb-4 shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5" className="text-primary font-weight-bold border-bottom pb-3 mb-4">
                Informasi Kontak & Alamat
              </CardTitle>
              <Row>
                {/* Bagian Kontak */}
                <Col md={12}><h6 className="font-weight-bold mb-3 text-secondary">A. Kontak yang dapat dihubungi</h6></Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Handphone <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_mobile_phone_number"
                      placeholder="Handphone"
                      type="text"
                      pattern="[0-9]*"
                      errorMessage="Masukkan Handphone"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        pattern: { value: '^[0-9]+$', errorMessage: 'Hanya angka yang diperbolehkan' }
                      }}
                      id="employee_mobile_phone_number"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Telepon Rumah</Label>
                    <AvField
                      name="employee_phone_number"
                      placeholder="Telepon Rumah"
                      type="text"
                      errorMessage="Masukkan Telepon Rumah"
                      className="form-control"
                      id="employee_phone_number"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Email Internal <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_email_internal"
                      placeholder="Email"
                      type="email"
                      errorMessage="Masukkan Email"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="employee_email_internal"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Email Eksternal</Label>
                    <AvField
                      name="employee_email_external"
                      placeholder="Email"
                      type="email"
                      errorMessage="Masukkan Email"
                      className="form-control"
                      id="employee_email_external"
                    />
                  </AvGroup>
                </Col>

                {/* Bagian Alamat */}
                <Col md={12} className="mt-3"><h6 className="font-weight-bold mb-3 text-secondary">B. Detail Alamat</h6></Col>

                <Col md={6} className="d-flex flex-column mb-3">
                  <div className="p-3 bg-light rounded border flex-fill">
                    <h6 className="text-primary font-weight-bold mb-3 border-bottom pb-2">Alamat KTP</h6>

                    {/* Spacer tak terlihat agar sejajar rata horizontal dengan Checkbox di form Domisili */}
                    <AvGroup className="mb-3" style={{ visibility: 'hidden' }}>
                      <CustomInput type="checkbox" id="spacer_ktp" label="Spacer" />
                    </AvGroup>

                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Alamat KTP Lengkap <span className="text-danger">*</span></Label>
                      <AvField
                        name="employee_identity_address"
                        placeholder="Nama Jalan / RT RW"
                        type="textarea"
                        errorMessage="Masukkan Alamat KTP"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_identity_address"
                        value={this.state.identityAddress || ""}
                        onChange={(e) => {
                          this.setState({ identityAddress: e.target.value });
                          if (this.state.isSameAddress) this.setState({ domicileAddress: e.target.value });
                        }}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Provinsi <span className="text-danger">*</span></Label>
                      <CustomSelect
                        name="employee_identity_province_uuid"
                        errorMessage="Pilih Provinsi"
                        onChange={this.handleIdentitySelectProvince}
                        options={this.state.identityOptionProvince}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Provinsi"
                        defaultValue={this.state.selectedIdentityProvince?.value || this.state.selectedIdentityProvince}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kota/Kabupaten <span className="text-danger">*</span></Label>
                      <CustomSelect
                        name="employee_identity_city_uuid"
                        errorMessage="Pilih Kota"
                        onChange={this.handleIdentitySelectCity}
                        options={this.state.identityOptionCity}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Kota"
                        defaultValue={this.state.selectedIdentityCity?.value || this.state.selectedIdentityCity}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kecamatan</Label>
                      <CustomSelect
                        name="employee_identity_districts_uuid"
                        errorMessage="Pilih Kecamatan"
                        onChange={this.handleIdentitySelectDistrict}
                        options={this.state.identityOptionDistrict}
                        placeholder="Pilih Kecamatan"
                        defaultValue={this.state.selectedIdentityDistrict?.value || this.state.selectedIdentityDistrict}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Desa/Kelurahan</Label>
                      <CustomSelect
                        name="employee_identity_village_uuid"
                        errorMessage="Desa/Kelurahan"
                        options={this.state.identityOptionVillage}
                        placeholder="Desa/Kelurahan"
                        defaultValue={this.state.selectedIdentityVillage?.value || this.state.selectedIdentityVillage}
                        onChange={(opt) => {
                          this.setState({ selectedIdentityVillage: opt });
                          if (this.state.isSameAddress) this.setState({ selectedDomicileVillage: opt });
                        }}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kode Pos <span className="text-danger">*</span></Label>
                      <AvField
                        name="employee_identity_postal_code"
                        placeholder="Kode Pos"
                        type="text"
                        pattern="[0-9]*"
                        errorMessage="Masukkan Kode Pos"
                        className="form-control"
                        validate={{
                          required: { value: true },
                          pattern: { value: '^[0-9]+$', errorMessage: 'Hanya angka yang diperbolehkan' }
                        }}
                        id="employee_identity_postal_code"
                        value={this.state.identityPostalCode || ""}
                        onChange={(e) => {
                          this.setState({ identityPostalCode: e.target.value });
                          if (this.state.isSameAddress) this.setState({ domicilePostalCode: e.target.value });
                        }}
                      />
                    </AvGroup>
                  </div>
                </Col>

                <Col md={6} className="d-flex flex-column mb-3">
                  <div className="p-3 bg-light rounded border flex-fill">
                    <h6 className="text-primary font-weight-bold mb-3 border-bottom pb-2">Alamat Domisili / Tinggal</h6>

                    <AvGroup className="mb-3">
                      <CustomInput type="checkbox" id="same_as_ktp" label={<>&nbsp;&nbsp;Alamat Domisili Sama Dengan Alamat KTP</>} checked={this.state.isSameAddress} onChange={this.handleSameAddress} className="font-weight-bold text-success" />
                    </AvGroup>

                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Alamat Tinggal Lengkap <span className="text-danger">*</span></Label>
                      <AvField
                        name="employee_domicile_address"
                        placeholder="Nama Jalan / RT RW"
                        type="textarea"
                        errorMessage="Masukkan Alamat Tinggal"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_domicile_address"
                        value={this.state.domicileAddress || ""}
                        onChange={(e) => this.setState({ domicileAddress: e.target.value })}
                        disabled={this.state.isSameAddress}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Provinsi <span className="text-danger">*</span></Label>
                      <CustomSelect
                        name="employee_domicile_province_uuid"
                        errorMessage="Pilih Provinsi"
                        onChange={this.handleDomicileSelectProvince}
                        options={this.state.domicileOptionProvince}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Provinsi"
                        defaultValue={this.state.selectedDomicileProvince?.value || this.state.selectedDomicileProvince}
                        isDisabled={this.state.isSameAddress}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kota/Kabupaten <span className="text-danger">*</span></Label>
                      <CustomSelect
                        name="employee_domicile_city_uuid"
                        errorMessage="Pilih Kota"
                        onChange={this.handleDomicileSelectCity}
                        options={this.state.domicileOptionCity}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Kota"
                        defaultValue={this.state.selectedDomicileCity?.value || this.state.selectedDomicileCity}
                        isDisabled={this.state.isSameAddress}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kecamatan</Label>
                      <CustomSelect
                        name="employee_domicile_districts_uuid"
                        errorMessage="Pilih Kecamatan"
                        onChange={this.handleDomicileSelectDistrict}
                        options={this.state.domicileOptionDistrict}
                        placeholder="Pilih Kecamatan"
                        defaultValue={this.state.selectedDomicileDistrict?.value || this.state.selectedDomicileDistrict}
                        isDisabled={this.state.isSameAddress}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Desa/Kelurahan</Label>
                      <CustomSelect
                        name="employee_domicile_village_uuid"
                        errorMessage="Desa/Kelurahan"
                        options={this.state.domicileOptionVillage}
                        placeholder="Desa/Kelurahan"
                        defaultValue={this.state.selectedDomicileVillage?.value || this.state.selectedDomicileVillage}
                        onChange={(opt) => this.setState({ selectedDomicileVillage: opt })}
                        isDisabled={this.state.isSameAddress}
                      />
                    </AvGroup>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kode Pos <span className="text-danger">*</span></Label>
                      <AvField
                        name="employee_domicile_postal_code"
                        placeholder="Kode Pos"
                        type="text"
                        pattern="[0-9]*"
                        errorMessage="Masukkan Kode Pos"
                        className="form-control"
                        validate={{
                          required: { value: true },
                          pattern: { value: '^[0-9]+$', errorMessage: 'Hanya angka yang diperbolehkan' }
                        }}
                        id="employee_domicile_postal_code"
                        value={this.state.domicilePostalCode || ""}
                        onChange={(e) => this.setState({ domicilePostalCode: e.target.value })}
                        disabled={this.state.isSameAddress}
                      />
                    </AvGroup>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {/* ==========================================
              CARD 3: DATA KEPEGAWAIAN
          ========================================== */}
          <Card className="mb-4 shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5" className="text-primary font-weight-bold border-bottom pb-3 mb-4">
                Informasi Kepegawaian Utama
              </CardTitle>
              <Row>
                {this.state.categorySelected != "bf23fec1-b1a3-4242-a5d6-de19119be7db" ? ( // BUKAN HONORER
                  <>
                    <Col md={6}>
                      <AvGroup className="mb-3">
                        <Label className="font-weight-bold mb-1">TMT CPNS <span className="text-danger">*</span></Label>
                        <div className="customDatePickerWidth">
                          <DatePicker
                            name="tmt_cpns"
                            id="tmt_cpns"
                            placeholder="TMT CPNS"
                            errorMessage="Masukkan TMT CPNS"
                            isWeekday={false}
                            dateFormat="dd/MM/yyyy"
                            value={this.state.tmt_cpns}
                            onChange={(val) => this.setState({ tmt_cpns: val })}
                            validate={{ required: { value: true } }}
                          />
                        </div>
                      </AvGroup>
                    </Col>
                    <Col md={6}>
                      <AvGroup className="mb-3">
                        <Label className="font-weight-bold mb-1">TMT PNS <span className="text-danger">*</span></Label>
                        <div className="customDatePickerWidth">
                          <DatePicker
                            name="tmt_pns"
                            id="tmt_pns"
                            placeholder="TMT PNS"
                            errorMessage="Masukkan TMT PNS"
                            isWeekday={false}
                            dateFormat="dd/MM/yyyy"
                            value={this.state.tmt_pns}
                            onChange={(val) => this.setState({ tmt_pns: val })}
                            validate={{ required: { value: true } }}
                          />
                        </div>
                      </AvGroup>
                    </Col>
                    <Col md={6}>
                      <AvGroup className="mb-3">
                        <Label className="font-weight-bold mb-1">Pangkat <span className="text-danger">*</span></Label>
                        <CustomSelect
                          name="employee_current_rank_uuid"
                          errorMessage="Pilih Pangkat"
                          placeholder="Pilih Pangkat"
                          options={this.state.rankOption}
                          onChange={(opt) => this.setState({ rankSelectedCode: opt?.code, rankSelectedValue: opt?.value })}
                          validate={{ required: { value: true } }}
                          defaultValue={this.state.rankSelectedValue}
                        />
                        <AvField name="cpns_candidate_rank_code" type="hidden" value={this.state.rankSelectedCode} />
                      </AvGroup>
                    </Col>
                    <Col md={6}>
                      <AvGroup className="mb-3">
                        <Label className="font-weight-bold mb-1">TMT Pangkat <span className="text-danger">*</span></Label>
                        <div className="customDatePickerWidth">
                          <DatePicker
                            name="rank_decree_date"
                            id="rank_decree_date"
                            placeholder="TMT Pangkat"
                            errorMessage="Masukkan TMT Pangkat"
                            isWeekday={false}
                            dateFormat="dd/MM/yyyy"
                            value={this.state.rank_decree_date}
                            onChange={(val) => this.setState({ rank_decree_date: val })}
                            validate={{ required: { value: true } }}
                          />
                        </div>
                      </AvGroup>
                    </Col>
                  </>
                ) : null}



                {/* ID Card Ketenagakerjaan dll */}
                <Col md={12} className="mt-3"><h6 className="font-weight-bold mb-3 text-secondary">Identitas Pendukung & Asuransi</h6></Col>

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Askes / BPJS Kesehatan</Label>
                    <AvField
                      name="employee_askes_number"
                      placeholder="Askes / BPJS Kesehatan"
                      type="text"
                      errorMessage="Masukkan Askes / BPJS Kesehatan"
                      className="form-control"
                      id="employee_askes_number"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Tapera</Label>
                    <AvField
                      name="employee_tapera_number"
                      placeholder="Tapera"
                      type="text"
                      errorMessage="Masukkan Tapera"
                      className="form-control"
                      id="employee_tapera_number"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Taspen</Label>
                    <AvField
                      name="employee_taspen_number"
                      placeholder="Taspen"
                      type="text"
                      errorMessage="Masukkan Taspen"
                      className="form-control"
                      id="employee_taspen_number"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">NPWP</Label>
                    <AvField
                      name="employee_npwp_number"
                      placeholder="NPWP"
                      type="text"
                      errorMessage="Masukkan NPWP"
                      className="form-control"
                      id="employee_npwp_number"
                    />
                  </AvGroup>
                </Col>
                {this.state.categorySelected != "bf23fec1-b1a3-4242-a5d6-de19119be7db" ? ( // BUKAN HONORER
                  <Col md={6}>
                    <AvGroup className="mb-3">
                      <Label className="font-weight-bold mb-1">Kartu Pegawai <span className="text-danger">*</span></Label>
                      <AvField
                        name="employee_karpeg_number"
                        placeholder="Kartu Pegawai"
                        type="text"
                        errorMessage="Masukkan Kartu Pegawai"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_karpeg_number"
                      />
                    </AvGroup>
                  </Col>
                ) : null}

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Nomor Dosir</Label>
                    <AvField
                      name="employee_dosir_number"
                      placeholder="Nomor Dosir"
                      type="text"
                      errorMessage="Masukkan Nomor Dosir"
                      className="form-control"
                      id="employee_dosir_number"
                    />
                  </AvGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {/* ==========================================
              CARD 4: DATA BANK & GAJI
          ========================================== */}
          <Card className="mb-4 shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5" className="text-primary font-weight-bold border-bottom pb-3 mb-4">
                Informasi Bank & Gaji
              </CardTitle>
              <Row>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Status Penggajian <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_salary_paid_from"
                      errorMessage="Pilih Status Penggajian"
                      options={this.state.OptionSallaryFrom}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Status Penggajian"
                      defaultValue={this.state.salaryPaidFromSelected}
                      onChange={(opt) => this.setState({ salaryPaidFromSelected: opt?.value })}
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Bank <span className="text-danger">*</span></Label>
                    <CustomSelect
                      name="employee_bank_uuid"
                      errorMessage="Pilih Bank"
                      options={this.state.OptionBank}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Bank"
                      defaultValue={this.state.bankSelectedValue}
                      onChange={(opt) =>
                        this.setState({
                          bankSelectedName: opt?.label,
                          bankSelectedValue: opt?.value
                        })
                      }
                    />
                    <AvField type="hidden" name="employee_categories_bank_name" value={this.state.bankSelectedName || ""} />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Rekening Gaji <span className="text-danger">*</span></Label>
                    <AvField
                      name="employee_bank_account_number"
                      placeholder="Nomor Rekening"
                      type="text"
                      pattern="[0-9]*"
                      errorMessage="Masukkan Rekening Gaji"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        pattern: { value: '^[0-9]+$', errorMessage: 'Hanya angka yang diperbolehkan' }
                      }}
                      id="employee_bank_account_number"
                    />
                  </AvGroup>
                </Col>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Nama Pemilik Rekening</Label>
                    <AvField
                      name="employee_bank_account_name"
                      placeholder="Nama di Rekening"
                      type="text"
                      errorMessage="Masukkan Nama Pemilik"
                      className="form-control"
                      id="employee_bank_account_name"
                    />
                  </AvGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {/* ==========================================
              CARD 5: POLA KERJA
          ========================================== */}
          <Card className="mb-4 shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5" className="text-primary font-weight-bold border-bottom pb-3 mb-4">
                Pola Kerja
              </CardTitle>
              <Row>
                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label htmlFor="mapping_working_pattern_working_pattern_uuid" className="font-weight-bold mb-1">
                      Pola Kerja <span className="text-danger">*</span>
                    </Label>
                    <CustomSelect
                      name={`mapping_working_pattern_working_pattern_uuid`}
                      errorMessage="Pilih Pola Kerja"
                      options={this.state.polaKerjaOptions}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Pola Kerja"
                      isLoading={this.state.isLoadingOptPolaKerja}
                      defaultValue={this.state.selectedPolaKerja}
                      onChange={(v) =>
                        this.setState({
                          selectedPolaKerja: v.model,
                        })
                      }
                    />
                  </AvGroup>
                </Col>



                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Tanggal Mulai <span className="text-danger">*</span></Label>
                    <div className="customDatePickerWidth">
                      <DatePicker
                        name="mapping_working_pattern_start_date"
                        placeholder="Tanggal Mulai"
                        errorMessage="Masukkan Tanggal Mulai"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        value={this.state.mapping_working_pattern_start_date}
                        onChange={(val) => this.setState({ mapping_working_pattern_start_date: val })}
                        validate={{ required: { value: true } }}
                      />
                    </div>
                  </AvGroup>
                </Col>

                <Col md={6}>
                  <AvGroup className="mb-3">
                    <Label className="font-weight-bold mb-1">Tanggal Selesai <span className="text-danger">*</span></Label>
                    <div className="customDatePickerWidth">
                      <DatePicker
                        name="mapping_working_pattern_end_date"
                        placeholder="Tanggal Selesai"
                        errorMessage="Masukkan Tanggal Selesai"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        value={this.state.mapping_working_pattern_end_date}
                        onChange={(val) => this.setState({ mapping_working_pattern_end_date: val })}
                        validate={{ required: { value: true } }}
                      />
                    </div>
                  </AvGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

        </div>
      </Fragment>
    );
  }
}

export default FormPegawaiBaru;
